import axios from "axios";
import { Tooltip } from "@/components";
import config from '@/config'
import store from '@/store'
import i18n from './vue-i18n'
import errorInfo from './error.json'
const instance = axios.create({
  baseURL: process.env.NODE_ENV === 'development'?"/api/v1": config.APIBASEURL,
  timeout: 60000
});

instance.interceptors.request.use(
  function(config) {
    const token = sessionStorage.getItem("MASS_WALLET_Token");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function(response) {
    if(response.data.err_code == 4) {
      store.user.dispath('logout')
      window.location.reload()
      return response.data
    }
    return response.data;
  },
  function(error) {
    if (error.response && error.response.data.err_code && error.response.data.err_code != 7) {
      Tooltip.error(errorInfo[error.response.data.err_type][i18n.locale]);
    }
    if((error.response.data.err_code && error.response.data.err_code == 4) || error.code === "ECONNABORTED") {
      store.user.dispath('logout')
      window.location.reload()
      return ''
    }
    return Promise.reject(error.message);
  }
);
const Http = function({ data = {}, url, params = {}, method }) {
  return instance({
    method,
    url,
    params,
    data,
  });
};

export default Http;
